import { Component,  Input, OnInit } from '@angular/core';
import { Program } from 'globals/store/programs.data';
import { getXYFromEventAndWidth } from '../../helpers/helpers';
import { RankSelectDialogComponent, RankingDialogData } from '../sponsors/rank-select.dialog.component';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { Wrapper } from '../../components/wrapper.component';
import { Dictionary } from '@ngrx/entity';
import { ActionButtonComponent } from 'src/app/components/nav-bar/action-button.component';
import { jsonCopyObject } from 'globals/helpers/helpers';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'edit-cue-columns',
    template: `
<action-button *ngIf="!!programs[programId]" [text]="'Edit cue columns'" (click)="editCueColumns($event)"></action-button>
`,
    standalone: true,
    imports: [ActionButtonComponent, CommonModule]
})
export class EditCueColumnsComponent extends Wrapper<EditCueColumnsComponent> implements OnInit {
  @Input() programId: string
  programs: Dictionary<Program>

  ngOnInit() {
    this.subProp(this.store.select('programs', 'entities'), 'programs')
  }

  async editCueColumns(event: MouseEvent) {
    const { y: top, x: left } = getXYFromEventAndWidth(event, 300)
    const position = { top, left }
    const { hiddenCueCols, cueCols: oldCueCols } = this.programs[this.programId]
    const oldSelectedIds = oldCueCols.map(c => c.id).filter(id => !(hiddenCueCols || []).includes(id))

    const data: RankingDialogData = {
      position,
      ranks: jsonCopyObject(oldCueCols),
      type: 'Cue column',
      message: 'Drag the columns below to reorder in this room/location',
      deleteLocation: 'room/location',
      selectedIds: jsonCopyObject(oldSelectedIds)
    }
  
    const oldRanksSerialized = JSON.stringify(data.ranks)
    const returnValue: RankingDialogData = await openDialogGetResult(this.dialog, RankSelectDialogComponent, { width: '300px', disableClose: true, data, backdropClass: 'clear' }) // mutates data in place
    const { ranks: cueCols, selectedIds } = returnValue
    
    const programUpdate: Partial<Program> = {}
    if (JSON.stringify(cueCols) !== oldRanksSerialized) {
      programUpdate.cueCols = cueCols
    }
    if (JSON.stringify(oldSelectedIds) !== JSON.stringify(selectedIds)) {
      programUpdate.hiddenCueCols = cueCols.map(c => c.id).filter(id => !selectedIds.includes(id))
    }
    if (!!Object.keys(programUpdate).length) {
      this.programService.sendProgramUpdate(this.programId, programUpdate)
    }
  }
}

